/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 Link — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviation: link color via NS interactive-fg tokens (mode-aware) i.p.v.
// MUI default palette.primary.main. Hover via interactive-fg-hover.
// transition: none (ground-rules.md "Motion and text": geen animatie).

export const MuiLinkLightOverrides = {
  root: {
    color: 'var(--ns-color-fg-interactive-default)',
    transition: 'none',
    '&:hover': {
      color: 'var(--ns-color-fg-interactive-hover)',
    },
    '&:focus-visible': {
      outline: '2px solid var(--ns-color-fg-interactive-default)',
      outlineOffset: 2,
    },
  },

  underlineNone: {
    textDecoration: 'none' as const,
  },

  underlineHover: {
    textDecoration: 'none' as const,
    '&:hover': {
      textDecoration: 'underline' as const,
    },
  },

  underlineAlways: {
    textDecoration: 'underline' as const,
  },

  // Same reset as ButtonBase.root, MUI Link met `component="button"`.
  button: {
    position: 'relative' as const,
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    outline: 0,
    border: 0,
    margin: 0,
    borderRadius: 0,
    padding: 0,
    cursor: 'pointer' as const,
    userSelect: 'none' as const,
    verticalAlign: 'middle' as const,
    MozAppearance: 'none' as const,
    WebkitAppearance: 'none' as const,
    '&::-moz-focus-inner': {
      borderStyle: 'none' as const,
    },
    '&$focusVisible': {
      outline: 'auto',
    },
  },

  focusVisible: {},
} as const;

// Dark variant — alle kleur-tokens zijn mode-aware via tokens.css.
export const MuiLinkDarkOverrides = {
  ...MuiLinkLightOverrides,
} as const;
